module.exports = __webpack_public_path__ + "static/media/ryanHuttonJztmx9yqjbwUnsplash.ec79c7eb.jpg";